import { gql, useMutation, useQuery } from '@apollo/client'

import {
  BankCreateQuery,
  BankCreateQueryVariables,
  RegisterUserBankMutation,
  RegisterUserBankMutationVariables,
  UserBankInput,
} from '@/clients/utoniq-core/schema'
import { useMessage, useRouter, useTranslation } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { showError, showMessage } = useMessage()
  const { t } = useTranslation('bankCreate')
  const { router, routerPages } = useRouter()
  const { data } = useQuery<BankCreateQuery, BankCreateQueryVariables>(QUERY)

  const [registerUserBank, { loading: submitting }] = useMutation<
    RegisterUserBankMutation,
    RegisterUserBankMutationVariables
  >(REGISTER_USER_BANK)

  return {
    state: {
      bank: data?.user?.bank ?? null,
      submitting,
    },
    actions: {
      async onSubmit(inputs: UserBankInput) {
        return registerUserBank({
          variables: { inputs },
        })
          .then(() => {
            showMessage(t('success'))
            return router.goBack(routerPages.AccountSetting)
          })
          .catch(showError)
      },
    },
  }
})

const QUERY = gql`
  query bankCreate {
    user {
      id
      bank {
        accountHolderName
        accountNumber
        accountType
        bankName
        branchCode
        branchName
      }
    }
  }
`

const REGISTER_USER_BANK = gql`
  mutation registerUserBank($inputs: UserBankInput!) {
    registerUserBank(inputs: $inputs) {
      id
    }
  }
`
